export default[
    {
        path:'/',
        name:'index',
        component: ()=>import('@/pages/index/index.vue')
    }
]